import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/Card'

export const Warehouse = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-3xl font-bold text-gray-900">Warehouse</h1>
      </div>
      
      <Card>
        <CardHeader>
          <CardTitle>Warehouse Management</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-center py-12">
            <div className="text-4xl mb-4">🏪</div>
            <h3 className="text-lg font-medium mb-2">Warehouse Module</h3>
            <p className="text-gray-500">Warehouse management features coming soon...</p>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}